import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ResizeService } from '../shared/resize.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  standalone: false,
})
export class AuthComponent {
  screenType!: string;
  currentYear: string | null = null;

  constructor(
    private resizeService: ResizeService,
    private datePipe: DatePipe
  ) {
    this.currentYear = this.datePipe.transform(new Date(), 'yyyy');
    this.resizeService.screenWidthChange$.subscribe({
      next: (res: string) => {
        this.screenType = res;
      },
    });
  }
}
